import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { pageTitle } from '../../helper'
import Accordion from '../Accordion'
import Button from '../Button'
import Cta from '../Cta'
import IconBox from '../IconBox'
import PageHeading from '../PageHeading'
import Div from '../Div'
import SectionHeading from '../SectionHeading'
import TestimonialSlider from '../Slider/TestimonialSlider'
import Spacing from '../Spacing'

export default function UiUxDesignPage() {
    pageTitle('UI/UX Design Services');
    const params = useParams();
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <>
            <PageHeading
                title='UI/UX Design Services'
                bgSrc='/images/service_hero_bg.jpeg'
                pageLinkText={params.serviceDetailsId || 'UI/UX Design'}
            />
            <Spacing lg='145' md='80'/>
            <Div className="container">
                <SectionHeading
                    title='Design Working Process'
                    subtitle='UI/UX Design'
                    variant='cs-style1 text-center'
                />
                <Spacing lg='90' md='45'/>
                <Div className="row">
                    <Div className="col-lg-4">
                        <IconBox
                            icon='/images/icons/service_icon_1.svg'
                            title='Sketching'
                            subtitle='Our design journey begins with sketching - the foundation of all great digital experiences. We transform abstract concepts into tangible visuals, exploring multiple directions to find the perfect solution for your business needs.'
                        />
                        <Spacing lg='30' md='30'/>
                    </Div>
                    <Div className="col-lg-4">
                        <IconBox
                            icon='/images/icons/service_icon_2.svg'
                            title='Wireframing'
                            subtitle='With concepts refined, we develop detailed wireframes that establish the structural blueprint of your interface. This critical step allows us to optimize user flows, information architecture, and interaction patterns before visual design begins.'
                        />
                        <Spacing lg='30' md='30'/>
                    </Div>
                    <Div className="col-lg-4">
                        <IconBox
                            icon='/images/icons/service_icon_3.svg'
                            title='Prototyping'
                            subtitle='Bringing wireframes to life, our interactive prototypes simulate the actual user experience, allowing stakeholders to test and validate designs before development begins. Through rigorous prototype testing, we identify and resolve usability issues early.'
                        />
                        <Spacing lg='30' md='30'/>
                    </Div>
                </Div>
            </Div>
            <Spacing lg='120' md='50'/>
            <Div className="container">
                <Div className="row">
                    <Div className="col-lg-6">
                        <h2 className="cs-font_30 cs-m0">Transform your digital experience</h2>
                        <Spacing lg='30' md='30'/>
                        <p>At ACE Cloud Solution, we transform complex user experiences into intuitive, engaging interfaces that delight your customers. Our comprehensive UI/UX design process ensures your digital products not only look stunning but deliver exceptional functionality.</p>
                        <p>We create seamless, intuitive experiences that engage your users and drive conversions. Through careful research, strategic design, and continuous testing, we deliver interfaces that not only look beautiful but perform beautifully as well.</p>
                        <Spacing lg='30' md='30'/>
                        <h3 className="cs-font_22 cs-m0">Key benefits of our approach:</h3>
                        <Spacing lg='15' md='15'/>
                        <ul className="cs-list cs-style1">
                            <li>User-centered design that prioritizes actual user needs and behaviors</li>
                            <li>Research-driven insights that inform strategic design decisions</li>
                            <li>Iterative testing and refinement to ensure optimal usability</li>
                            <li>Cohesive design systems that maintain consistency across products</li>
                            <li>Accessible interfaces that comply with WCAG guidelines</li>
                        </ul>
                    </Div>
                    <Div className="col-lg-5 offset-lg-1">
                        <Div className="cs-image_layer cs-style1">
                            <Div className="cs-image_layer_in">
                                <img src="/images/service_1.jpeg" alt="UI/UX Design" className="w-100" />
                            </Div>
                        </Div>
                        <Spacing lg='0' md='40'/>
                    </Div>
                </Div>
            </Div>
            <Spacing lg='100' md='80'/>
            <Div className="container">
                <Div className="row align-items-center">
                    <Div className="col-xl-5 col-lg-6">
                        <Div className="cs-radius_15 cs-shine_hover_1">
                            <img src="/images/service_img_1.jpeg" alt="Service" className='cs-radius_15 w-100' />
                        </Div>
                        <Spacing lg='0' md='40'/>
                    </Div>
                    <Div className="col-lg-6 offset-xl-1">
                        <h2 className="cs-font_50 cs-m0">Below our most design related services</h2>
                        <Spacing lg='50' md='30'/>
                        <Div className="row">
                            <Div className="col-lg-6">
                                <Button btnLink='' btnText='Web page design' variant='cs-type2'/>
                                <Spacing lg='20' md='10'/>
                                <Button btnLink='' btnText='eCommerce design' variant='cs-type2'/>
                                <Spacing lg='20' md='10'/>
                                <Button btnLink='' btnText='Landing page' variant='cs-type2'/>
                                <Spacing lg='20' md='10'/>
                                <Button btnLink='' btnText='Email template' variant='cs-type2'/>
                                <Spacing lg='20' md='10'/>
                                <Button btnLink='' btnText='Application design' variant='cs-type2'/>
                                <Spacing lg='20' md='10'/>
                                <Button btnLink='' btnText='Illustration' variant='cs-type2'/>
                                <Spacing lg='0' md='10'/>
                            </Div>
                            <Div className="col-lg-6">
                                <Button btnLink='' btnText='Infographic design' variant='cs-type2'/>
                                <Spacing lg='20' md='10'/>
                                <Button btnLink='' btnText='Mobile apps design' variant='cs-type2'/>
                                <Spacing lg='20' md='10'/>
                                <Button btnLink='' btnText='Banner, brochure, card' variant='cs-type2'/>
                                <Spacing lg='20' md='10'/>
                                <Button btnLink='' btnText='User research & analysis' variant='cs-type2'/>
                                <Spacing lg='20' md='10'/>
                                <Button btnLink='' btnText='Usability testing' variant='cs-type2'/>
                                <Spacing lg='20' md='10'/>
                                <Button btnLink='' btnText='Other design services' variant='cs-type2'/>
                                <Spacing lg='0' md='10'/>
                            </Div>
                        </Div>
                    </Div>
                </Div>
            </Div>
            <Spacing lg='150' md='80'/>
            {/*<TestimonialSlider />*/}
            <Spacing lg='145' md='80'/>
            <Div className="container cs-shape_wrap_4">
                <Div className="cs-shape_4"></Div>
                <Div className="cs-shape_4"></Div>
                <Div className="container">
                    <Div className="row">
                        <Div className="col-xl-5 col-lg-6">
                            <SectionHeading
                                title='Some pre questions and answers'
                                subtitle="FAQ's"
              />
              <Spacing lg='90' md='45'/>
                        </Div>
                        <Div className="col-lg-6 offset-xl-1">
                            <Accordion/>
                        </Div>
                    </Div>
                </Div>
            </Div>
            <Spacing lg='150' md='80'/>
            <Div className="container">
                <Cta
                    title="Let's discuss make <br />something <i>amazing</i> together"
                    btnText='Schedule a Consultation'
                    btnLink='/contact'
                    bgSrc='/images/cta_bg.jpeg'
                    />
            </Div>
        </>
    )
}